<template>
  <div class="the-heading">
    <div class="the-heading-inner">
      <div class="title">
        <img
          :src="require('@/assets/images/logo.png')"
          alt="logo"
          class="logo"
        />
        <div class="logo-textcol">
            <div class="small-font">国家中医药古籍数字图书馆·
                <span v-if="sublibraryName">
                    地域医派馆
                </span>
                <span v-else>
                    古典医籍馆
                </span>
            </div>
            <div style="display: flex;align-items: center;">中国中医古籍数字资源库
                <div v-if="sublibraryName" class="small-font" style="margin-left:20px">
                    {{ sublibraryName }}
                </div>
            </div>
        </div>

        <!-- <span class="title-text">中国中医古籍数字资源库</span> -->
      </div>
      <div class="right-bar">
        <div class="user-card">
          <template v-if="isLogined">
            <div class="user-card-avatar">
              <img :src="avatarUrl" class="avatar" alt="avatar" />
            </div>
            <div class="user-card-name">
              {{ userName }}
            </div>
            <div class="user-card-link" @click="handleLogout">【退出】</div>
          </template>
          <template v-else>
            <my-dropdown
              class="login-dropdown"
              :autohidden="true"
              :animation="'fade'"
              ref="loginDropdown"
            >
              <template v-slot:title>
                <div class="user-card-link">【登录】</div>
              </template>
              <template v-slot:content>
                <login-form
                  class="login-form"
                  @login="handleLogin"
                  :logining="logining"
                  @register-success="form => handleRegisterSuccess(form)"
                  ref="loginForm"
                ></login-form>
              </template>
            </my-dropdown>

            <el-divider direction="vertical"></el-divider>
            <my-dropdown
              class="register-dropdown"
              :autohidden="true"
              :animation="'fade'"
              ref="registerDropdown"
            >
              <template v-slot:title>
                <div class="user-card-link">【注册】</div>
              </template>
              <template v-slot:content>
                <login-form
                  class="login-form"
                  @login="handleLogin"
                  @register-success="form => handleRegisterSuccess(form)"
                  :type="'register'"
                  ref="registerForm"
                ></login-form>
              </template>
            </my-dropdown>
          </template>
          <el-divider direction="vertical"></el-divider>
          <div class="user-card-link" @click="handleJumpHelpPage">【帮助】</div>
        </div>
        <div class="tab-bar">
          <div
            class="nav-button"
            v-for="item in buttons"
            :key="item.id"
            :class="{ active: activeIndex === item.id }"
            @click="handlePageChange(item.id)"
          >
            <img
              class="nav-button-icon"
              :src="activeIndex === item.id ? item.activeIcon : item.icon"
              :alt="item.text"
            />
            <span class="nav-button-text">{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>
    <my-dialog ref="confirmDialog" :title="'提示'"
      >确认要退出登录吗？</my-dialog
    >
    <my-dialog ref="registerSuccessDialog" :title="'注册成功'" :cancelButtonText="'暂不登录'"
      >是否打开登录界面？</my-dialog
    >
  </div>
</template>

<script>
import MyDropdown from './MyDropdown.vue'
import LoginForm from './LoginForm.vue'
import CryptoJS from 'crypto-js'
import MyDialog from './MyDialog.vue'
import ElementUI from 'element-ui'
import axios from 'axios'
export default {
  components: { MyDropdown, LoginForm, MyDialog },
  name: 'TheHeading',
  data () {
    return {
      activeIndex: 1,
      buttons: [
        {
          id: 1,
          icon: require('@/assets/images/headingIcons/home.png'),
          activeIcon: require('@/assets/images/headingIcons/homeActive.png'),
          text: '首页',
          path: '/home'
        },
        {
          id: 2,
          icon: require('@/assets/images/headingIcons/retrieve.png'),
          activeIcon: require('@/assets/images/headingIcons/retrieveActive.png'),
          text: '检索',
          path: '/retrieve'
        },
        {
          id: 3,
          icon: require('@/assets/images/headingIcons/user.png'),
          activeIcon: require('@/assets/images/headingIcons/userActive.png'),
          text: '个人中心',
          path: '/user'
        }
      ],
      isLogined: false,
      userName: '',
      trueName: '',
      role: '',
      logining: false,
      avatarUrl: '',
      lateReload: false,
      customBook: false,
      sublibraryName: '',
      brief: '',
      loginCount: 0,
      hasFakeLogin: false // 添加标志位
    }
  },
  mounted () {
    if (localStorage.getItem('hasFakeLogin')) {
      this.hasFakeLogin = localStorage.getItem('hasFakeLogin')
    }
    if (this.$route.params.url) {
      this.getSublibraryByUrl()
    }

    // 获取是否为游客登陆
    if (this.$route.query.vistor === 'true') {
      this.$refs.loginForm.vistorLogin()
    }

    // 获取当前页面的路径
    let path = this.$route.path
    if (this.$route.params.url) {
      path = '/' + path.split('/')[2]
    } else {
      path = '/' + path.split('/')[1]
    }
    this.buttons.forEach(item => {
      if (item.path === path) {
        this.activeIndex = item.id
      }
    })

    // 获取token并验证登录状态
    let token = localStorage.getItem('token')
    if (localStorage.getItem('isLogined') === 'true') {
      let url = 'retrieve/user/verifyToken'
      let params = new URLSearchParams()
      params.append('token', token)
      this.$http
        .post(url, params)
        .then(res => {
          if (res.data.status === 200) {
            this.getUserInfo()
            this.countCustomBookOfUser()
          } else {
            this.handleTokenExpired()
          }
        })
        .catch(err => {
          console.log(err)
          this.handleTokenExpired()
        })
    } else {
      this.tryAutoOrFakeLogin()
    }
  },
  methods: {
    getSublibraryByUrl () {
      let urlInfo = this.$route.params.url
      console.log('ss', urlInfo)
      let url = 'retrieve/user/getSublibraryByUrl'
      this.$http({
        method: 'get',
        url: url,
        params: {
          url: `/${urlInfo}`
        }
      }).then((res) => {
        if (res.status === 200 && res.data.status === 200) {
          console.log(res.data.data)
          this.sublibraryName = res.data.data.name
          this.brief = res.data.data.brief
          this.$global.brief = this.brief
          console.log('brief', this.brief)
          var newArray = this.buttons.filter(function (obj) {
            return obj.id !== 1
          })
          this.buttons = newArray
        }
      })
    },
    handlePageChange (index) {
      console.log('butindex', index)
      this.activeIndex = index
      if (this.buttons.length < 3) {
        this.$router.push({ path: this.buttons[index - 2].path })
      } else {
        this.$router.push({ path: this.buttons[index - 1].path })
      }
    },
    handleJumpHelpPage () {
      this.activeIndex = 0
      this.$router.push({ path: '/help' })
    },
    handleLogin (loginForm) {
      this.logining = true
      this.loginAction(loginForm)
    },
    handleLogout () {
      this.$refs.confirmDialog.open(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('sublibrary')
        localStorage.removeItem('userId')
        localStorage.removeItem('isLogined')
        localStorage.removeItem('trueName')
        localStorage.removeItem('userName')
        localStorage.removeItem('avatarUrl')
        localStorage.removeItem('defaultPermission')
        localStorage.setItem('hasFakeLogin', false)
        this.hasFakeLogin = false
        this.isLogined = false
        localStorage.setItem('isLogined', this.isLogined)
        localStorage.setItem('customBook', false)
        localStorage.setItem('defaultPermission', 40)
        if (localStorage.getItem('memberDeadline')) {
          localStorage.removeItem('memberDeadline')
        }
        // 个人中心同步更新数据
        // window.parent.test(event, this.isLogined)
        this.userName = ''
        this.trueName = ''
        this.role = ''
        this.$http.post('retrieve/user/logout').then(
          res => {
            console.log(res)
          },
          err => {
            console.log(err)
          }
        )
        // 清除30分钟无操作定时器
        if (this.$parent && this.$parent.clearInactivityTimer) {
          this.$parent.clearInactivityTimer()
        }
        this.$router.push({ path: '/home' })
        this.loginFakeUser()
      })
    },
    loginAction (loginForm) {
      //   console.log(loginForm)
      let { username, password, webUrl, rememberPassword } = loginForm
      //   console.log(username, password, rememberPassword)
      // 将Password转化为MD5
      let passwordmd5 = CryptoJS.MD5(password).toString()
      let params = new URLSearchParams()
      let url = 'retrieve/user/login'
      params.append('username', username)
      params.append('password', passwordmd5)
      params.append('url', webUrl)
      this.$http.post(url, params).then(
        res => {
          console.log('login', res.data.data)
          this.handleLoginSuccess(res)
        },
        err => {
          this.logining = false
          if (err.data.status === 27) {
            this.$refs.loginDropdown.show = false
            setTimeout(() => {
              this.$router.replace({
                path: '/changePassword?userId=' + err.data.data.userId
              })
            }, 1000)
          }
          if (err.data.status === 30) {
            ElementUI.Message.error(err.data.message)
            setTimeout(() => {
              window.location.reload() // 强制刷新
            }, 1000)
          }
          this.password = ''
          localStorage.setItem('rememberPassword', false)
          localStorage.removeItem('username')
          localStorage.removeItem('password')
          this.$refs.loginForm.loginForm.password = ''
        }
      )
    },
    logoutAction () {
      this.isLogined = false
      this.hasFakeLogin = false // 重置标志位
      localStorage.setItem('hasFakeLogin', false)
      localStorage.setItem('isLogined', this.isLogined)
      // 个人中心同步更新数据
      // window.parent.test(event, this.isLogined)
      this.userName = ''
      this.trueName = ''
      this.role = ''
      // 清除30分钟无操作定时器
      if (this.$parent && this.$parent.clearInactivityTimer) {
        this.$parent.clearInactivityTimer()
      }
      this.$http.post('retrieve/user/logout').then(
        res => {
          console.log(res)
        },
        err => {
          console.log(err)
        }
      )
      this.$router.push({ path: '/home' })
      this.loginFakeUser()
    },
    loginFakeUser (reload = false) {
      if (this.hasFakeLogin && !reload) return
      let userName = 'anonymity'
      let password = 'user_password'
      let passwordmd5 = CryptoJS.MD5(password).toString()
      let urlInfo = ''
      if (this.$route.params.url != undefined) {
        urlInfo = this.$route.params.url
      }
      let params = new URLSearchParams()
      let url = 'retrieve/user/login'
      params.append('username', userName)
      params.append('password', passwordmd5)
      params.append('url', `/${urlInfo}`)
      //   params.append('Ip', ip)
      this.$http.post(url, params).then(res => {
        console.log('login', res.data)
        localStorage.setItem('token', res.data.data.token)
        localStorage.setItem('sublibrary', res.data.data.sublibrary.name)
        localStorage.setItem('defaultPermission', 40)
        console.log(localStorage.getItem('userId'))
        this.hasFakeLogin = true
        localStorage.setItem('hasFakeLogin', true)
        let url2 = '/retrieve/user/getAvatar'
        let params2 = { userId: 80 }
        this.$http.get(url2, { params2 }).then(res => {
          this.avatarUrl = 'data:image/jpg;base64,' + res.data.data
          localStorage.setItem('avatarUrl', this.avatarUrl)
        })
        if (reload) {
          window.location.reload()
        }
        if (this.$route.params.url) {
          // 获取loginCount,如果不存在则初始化为0
          let count = parseInt(localStorage.getItem('loginCount') || '0')

          if (count === 0) {
            // 首次访问,设置loginCount并刷新
            localStorage.setItem('loginCount', '1')
            setTimeout(() => {
              console.log('首次访问')
              window.location.reload()
            }, 500)
          }
        }
      })
    },
    getUserInfo () {
      let url = 'retrieve/user/getPersonalIfo'
      let params = { userId: localStorage.getItem('userId') }
      this.$http.get(url, { params }).then(res => {
        console.log(res.data.data)
        localStorage.setItem('userId', res.data.data.id)
        localStorage.setItem('userName', res.data.data.username)
        localStorage.setItem('trueName', res.data.data.truename)
        this.userName = res.data.data.username
        this.trueName = res.data.data.truename
        this.isLogined = true
      })
      this.avatarUrl = localStorage.getItem('avatarUrl')
    },
    getRoleDefaultPermission (userId) {
      //   var userId = localStorage.getItem('userId')
      console.log('this.userId', userId)
      if (userId) {
        const params = new URLSearchParams()
        const url = 'retrieve/user/getRoleDefaultPermission'
        params.append('userId', userId)
        this.$http.post(url, params).then(res => {
          if (res.data.status === 200 && res.status === 200) {
            var info = res.data.data
            localStorage.removeItem('defaultPermission')
            localStorage.setItem('defaultPermission', info)
            let lateReloadTime = this.lateReload ? 1000 : 0
            setTimeout(() => {
              window.location.reload() // 强制刷新
            }, lateReloadTime)
            // window.location.reload(); // 强制刷新
          } else {
            this.$message({
              type: 'error',
              message: res.data
            })
          }
        })
      } else {
        localStorage.setItem('defaultPermission', 40)
      }
    },
    handleRegisterSuccess (form) {
      this.$refs.loginDropdown.show = false
      this.$refs.registerDropdown.show = false
      this.$refs.registerSuccessDialog.open(() => {
        this.$refs.loginForm.toLogin(form)
        setTimeout(() => { this.$refs.loginDropdown.show = true }, 300)
      })
    },
    autoLogin () {
      // 创建axios实例
      const instance = axios.create({ timeout: 10000 })
      if (!localStorage.getItem('token') ||
      !localStorage.getItem('userId') ||
      !localStorage.getItem('userName')) {
        instance.post('retrieve/user/autoLogin').then(res => {
          if (res.data.status === 200) {
            this.$message.success('机构用户自动登录成功')
            this.handleLoginSuccess(res)
          } else {
            if (res.data.data && res.data.data.message) {
              this.$message.error(res.data.data.message)
            }
            console.log("'机构用户自动登录失败'", res)
            if (res.data.status === 27) {
              this.$refs.loginDropdown.show = false
              setTimeout(() => {
                this.$router.replace({
                  path: '/changePassword?userId=' + res.data.data.userId
                })
              }, 1000)
            } else if (!this.hasFakeLogin) {
              this.loginFakeUser()
            }
          }
        })
      }
    },
    // token 失效后: 机构(IP)免登录用户优先重新自动登录, 失败再退回原有的退出逻辑
    // 该场景属于"超时后重新登录", 与首次自动登录(autoLogin)区分提示语
    // failMessage: 自动登录失败时展示的提示语
    handleTokenExpired (failMessage) {
      const instance = axios.create({ timeout: 10000 })
      instance.post('retrieve/user/autoLogin').then(
        res => {
          if (res.data && res.data.status === 200) {
            this.$message.success('长时间无操作，已刷新登录状态')
            this.handleLoginSuccess(res)
          } else {
            this.handleTokenExpiredFail(failMessage)
          }
        },
        err => {
          console.log(err)
          this.handleTokenExpiredFail(failMessage)
        }
      )
    },
    // 自动登录失败: 提示后走原有的退出登录逻辑
    handleTokenExpiredFail (failMessage) {
      if (failMessage) {
        ElementUI.Message.warning({ message: failMessage, duration: 5000 })
      }
      this.clearLoginInfo()
      this.logoutAction()
    },
    handleLoginSuccess (res) {
      localStorage.setItem('token', res.data.data.token)
      localStorage.setItem('userId', res.data.data.user.id)
      localStorage.setItem('sublibrary', res.data.data.sublibrary.name)
      localStorage.setItem('userName', res.data.data.user.username)
      localStorage.setItem('trueName', res.data.data.user.truename)
      console.log('handleLoginSuccess', res.data.data.user)
      if (res.data.data.isExpireMember) {
        setTimeout(() => {
          ElementUI.Message.warning('您的会员已过期，请续费')
          localStorage.removeItem('defaultPermission')
          localStorage.setItem('defaultPermission', 40)
        }, 1000)

        setTimeout(() => {
          window.location.reload() // 强制刷新
        }, 2000)
      } else {
        this.getRoleDefaultPermission(res.data.data.user.id)
      }

      if (res.data.data.loginWarnMessage !== null) {
        this.lateReload = true
        ElementUI.Message.warning(res.data.data.loginWarnMessage)
      }

      if (res.data.data.passwordExpiry !== null) {
        this.lateReload = true
        ElementUI.Message.warning(res.data.data.passwordExpiry)
      }
      if (res.data.data.user.memberDeadline) {
        localStorage.setItem(
          'memberDeadline',
          res.data.data.user.memberDeadline
        )
      }
      this.isLogined = true
      localStorage.setItem('isLogined', this.isLogined)
      this.userName = res.data.data.user.username
      this.trueName = res.data.data.user.truename
      this.role = res.data.data.role[0]
      this.logining = false
      console.log('userId', localStorage.getItem('userId'))
      let url = '/retrieve/user/getAvatar'
      let params = { userId: res.data.data.user.id }
      this.$http.get(url, { params }).then(res => {
        this.avatarUrl = 'data:image/jpg;base64,' + res.data.data
        localStorage.setItem('avatarUrl', this.avatarUrl)
      })
      // 检测用户是否登录，如果登录了，启动30分钟无操作退出登录功能
      if (this.isLogined && this.$parent && this.$parent.startInactivityTimer) {
        this.$parent.startInactivityTimer()
      }

    },
    countCustomBookOfUser () {
      let url1 = 'retrieve/search/countCustomBookOfUser'
      this.$http.get(url1).then(res => {
        console.log('res', res.data)
        if (Number(res.data.data) > 0) {
          this.customBook = true
        }
        localStorage.setItem('customBook', this.customBook)
      })
    },
    // 添加新方法处理登录信息清除
    clearLoginInfo () {
      localStorage.removeItem('userId')
      localStorage.removeItem('token')
      localStorage.removeItem('sublibrary')
      localStorage.setItem('customBook', false)
    },

    // 添加新方法处理自动登录和游客登录
    tryAutoOrFakeLogin () {
      // if (this.hasFakeLogin) return

      if (this.$route.path === '/home' || this.$route.path === '/' || this.$route.path.includes('introduction')) {
        this.autoLogin()
      } else if (!this.hasFakeLogin) {
        this.loginFakeUser()
      }
    }
  },
  watch: {
    $route (to, from) {
      // 获取当前页面的路径
      if (this.$route.params.url) {
        this.getSublibraryByUrl()
      }
      let path = this.$route.path
      path = '/' + path.split('/')[1]
      if (path === '/bookDetail') {
        path = '/retrieve'
      }
      // 根据路径设置activeIndex
      this.buttons.forEach(item => {
        if (item.path === path) {
          this.activeIndex = item.id
        }
      })
      this.$refs.loginDropdown.show = false
    }
  }
}
</script>

<style scoped>
.the-heading {
  height: 125px;
  background-image: url(../assets/images/homeImage/header.png);
  background-size: 1920px;
  padding-bottom: 20px;
  background-color: #f7efe7;
}

.the-heading-inner {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  /* background-color: #bc8f5a; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: 30px;
  color: #fff;
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
}

.logo {
  height: 80px;
}

.the-heading >>> .el-divider--vertical {
  height: 30px;
  width: 2px;
  background-color: #fff;
}

.right-bar {
  display: flex;
  flex-direction: column;
  align-items: right;
  justify-content: space-between;
  margin-top: auto;
}

.user-card {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 30px;
}

.user-card-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: -25px;
  z-index: 2;
}

.user-card-name {
  height: 42px;
  min-width: 80px;
  max-width: 240px;
  background-color: #f1e6d9;
  display: flex;
  border-radius: 21px;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #9e5c1d;
  margin-right: 6px;
  padding-left: 27px;
  padding-right: 10px;
}

.user-card-link {
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
}

.tab-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
}

.nav-button {
  height: 44px;
  width: 122px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background-color: rgba(255, 255, 255, 0.5);
  color: #9e5c1d;
  cursor: pointer;
  margin-left: 8px;
}

.nav-button-icon {
  height: 24px;
  margin-right: 10px;
}

.nav-button-text {
  min-width: 52px;
  text-align-last: justify;
  text-align: justify;
  text-justify: distribute-all-lines;
}

.nav-button:hover {
  background-color: rgba(255, 255, 255, 0.8);
}

.nav-button.active {
  background-color: #9e5c1d;
  color: #fff;
}

.login-dropdown >>> .my-dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 450px;
  min-height: 407px;
  top: 120px;
  left: -225px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 9999;
}

.register-dropdown >>> .my-dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 450px;
  min-height: 407px;
  top: 120px;
  left: -307px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.avatar {
  width: 42px;
  height: 42px;
}

.logo-textcol{
    font-family: mysong;
    font-weight: heavy;
    text-align: left;
    padding-left: 30px;
    font-size: 30px;
}
.small-font{
    font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/TheHeading.vue